import type {FC} from 'react';
import {memo} from 'react';

import TopMenuPublic from '@src/modules/TopMenuPublic/TopMenuPublic';

interface Props {
  loginButtonText?: string;
}

const TopMenuLayoutPublic: FC<Props> = ({loginButtonText}) => {
  return (
    <div className="TopMenuLayoutPublic">
      <TopMenuPublic loginButtonText={loginButtonText} />
    </div>
  );
};

export default memo(TopMenuLayoutPublic);
